import styled from "styled-components";

export const Container = styled.div`
  width: 33rem;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

export const Empty = styled.div`
  height: 4rem;
`;

export const IconDiv = styled.div`
  width: 4rem;
  height: 4rem;

  background: linear-gradient(180deg, #cff8e7 0%, rgba(174, 220, 201, 0) 100%);
  border-radius: 0.4rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: space-around;

  svg {
    width: 2.85rem;
    height: 2.85rem;
    margin: 0.605rem;
  }
`;

export const Header = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: normal;
  font-size: 1.21rem;
  line-height: 1.525rem;

  text-align: center;
  color: #42464c;
`;

export const SubHeader = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: normal;
  font-size: 0.94rem;
  line-height: 1.215rem;
  color: #7e858f;

  padding: 1rem 0rem 2rem;
`;

export const LinkDiv = styled.div`
  padding: 1rem 0rem 3rem;

  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 0.807rem;
  line-height: 1rem;
`;
